import { render, staticRenderFns } from "./TestbuyBaseInfo.vue?vue&type=template&id=ed03ad74"
import script from "./TestbuyBaseInfo.vue?vue&type=script&lang=js"
export * from "./TestbuyBaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports